---
title: Termos
updated: 2026-10-02
---

## 1. Aceitação dos Termos

Ao criar uma conta ou usar o Draughts Game ("o Serviço"), você concorda em ficar vinculado a estes Termos de Serviço. Se você não concorda, por favor não use o Serviço.

## 2. Descrição do Serviço

O Draughts Game é uma plataforma online para jogar damas em várias variantes. O Serviço inclui pareamento com outros jogadores ou com o computador, torneios, rating dos jogadores, problemas táticos e recursos de análise de partidas.

## 3. Cadastro de conta

Para acessar certos recursos, você precisa criar uma conta informando um nome de usuário, um endereço de e-mail e uma senha. Você precisa verificar o seu endereço de e-mail antes de poder entrar. Você é responsável por manter em sigilo as credenciais da sua conta. Você também pode jogar como convidado, sem cadastro, com funcionalidades limitadas.

- Você precisa ter pelo menos 16 anos para criar uma conta.
- Você pode criar apenas uma conta por pessoa.
- Você é responsável por toda a atividade realizada na sua conta.

## 4. Conduta do usuário

Ao usar o Serviço, você concorda em não:

- Usar ajuda externa (motores, solvers) durante partidas valendo rating.
- Perder partidas de propósito para manipular o rating (sandbagging).
- Combinar resultados com outros jogadores em torneios.
- Assediar, ameaçar ou ofender outros usuários.
- Criar várias contas para burlar banimentos ou manipular a classificação.
- Tentar explorar falhas ou vulnerabilidades da plataforma.
- Usar ferramentas automatizadas (bots) para jogar sem autorização.

## 5. Jogo limpo

Reservamo-nos o direito de usar sistemas automatizados para detectar trapaça e jogo desleal. As violações podem resultar em advertências, suspensões temporárias, ajustes de rating ou banimento definitivo, a nosso critério.

## 6. Propriedade intelectual

O Serviço, incluindo o seu design, código original, gráficos e conteúdo, pertence ao Draughts Game. Os registros das partidas (lances, resultados) são dados públicos e podem ser compartilhados livremente. O conteúdo criado pelos usuários (nomes de usuário, mensagens de bate-papo) continua sendo propriedade dos seus respectivos autores.

## 7. Disponibilidade e alterações

Nós nos empenhamos em manter o Serviço sempre disponível, mas não garantimos acesso ininterrupto. Reservamo-nos o direito de alterar, suspender ou encerrar qualquer parte do Serviço a qualquer momento. Podemos atualizar estes Termos de tempos em tempos. Continuar usando o Serviço depois das mudanças significa aceitá-las.

## 8. Limitação de responsabilidade

O Serviço é fornecido "no estado em que se encontra", sem garantias de nenhum tipo, expressas ou implícitas. Não somos responsáveis por danos indiretos, incidentais ou consequenciais decorrentes do uso do Serviço. A nossa responsabilidade total não excederá o valor que você tiver nos pago nos 12 meses anteriores à reclamação (se houver).

## 9. Encerramento

Você pode excluir a sua conta a qualquer momento nas configurações do seu perfil ("Excluir a conta") ou entrando em contato conosco. Podemos encerrar ou suspender a sua conta se você violar estes Termos ou adotar conduta prejudicial ao Serviço ou a outros usuários.

## 10. Contato

Para dúvidas sobre estes Termos, entre em contato pelo endereço: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
